import { TargetingProvider } from '@openx/components-targeting/utils/context/TargetingContext.tsx';
import { targetingConfig } from '@openx/components-targeting/utils/hooks/unityConfig.ts';
import { PermissionProvider } from '@openx/utils/permission/context/PermissionContext.tsx';
import { permissionConfig } from '@openx/utils/permission/context/unityConfig.ts';
import type React from 'react';
import { GROWTHBOOK_SALT } from '../config.ts';

export interface ConfigProvidersProps {
  children: React.ReactNode;
}

export function ConfigProviders({ children }: ConfigProvidersProps) {
  return (
    <PermissionProvider
      permissionConfig={permissionConfig}
      appName={null}
      userEmail={undefined}
      growthBookSalt={GROWTHBOOK_SALT}
    >
      <TargetingProvider targetingConfig={targetingConfig}>{children}</TargetingProvider>
    </PermissionProvider>
  );
}
